import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Nav_Interface } from 'src/app/Interface/Nav_Interface';
import { Empty_User_Interface, User_Interface } from 'src/app/Interface/User_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LoginService } from 'src/app/Service/Login/Login.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { UserService } from 'src/app/Service/User/User.service';

@Component({
  selector: 'app-UserList',
  templateUrl: './UserList.component.html',
  styleUrls: ['./UserList.component.scss']
})
export class UserListComponent implements OnInit {
  Token: string = ""
  Filter_Name: string = ""
  Filter_Familly: string = ""
  Filter_Username: string = ""
  page: number = 0;
  Procssing: boolean = false

  modalRef_Delete: any;

  constructor(
    private User_Service: UserService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    private loginService: LoginService,
    public router: Router,
    private modalService: BsModalService
  ) { }


  DataList_User: Array<User_Interface> = []
  Data_Seleted_Delete: User_Interface = Empty_User_Interface()

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');

    this.Nav_Service.CheckValidPage(this.Token, 22).subscribe(
      data => {
        this.ReadData_User()
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )


  }

  ReadData_User() {
    this.Procssing = true
    this.User_Service.GetRecord(this.Token).subscribe(
      data => {
        this.DataList_User = data
        this.Procssing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  Change_Filter() {
    this.page = 0
  }

  Delete(item: User_Interface) {
    item.DeletingProccess = true
    this.modalRef_Delete.hide()
    this.User_Service.DeleteUser(item.id, this.Token).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("Deleted successfully.")
        this.ReadData_User()
      }, error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  openModal(template: TemplateRef<any>, Record) {
    this.Data_Seleted_Delete = Record
    this.modalRef_Delete = this.modalService.show(template);
  }


  AutoLogin(item:User_Interface): void {

    this.Procssing = true
    this.loginService.AutoLogin(this.Token,item.id).subscribe(
      response => {

        if (response['token'] == '-1') {
          this.Procssing = false
          this.Alertify_Service.ErrorMessage("This account is currently signed in and active.")
        }
        else {

          this.Alertify_Service.SuccessMessage(response['fullname'] + ", welcome.")
          localStorage.setItem('Daro_User_Token', response['token']);
          localStorage.setItem('Daro_User_UserImage', response['userImage']);
          localStorage.setItem('Daro_User_Fullname', response['fullname']);
          localStorage.setItem('Daro_User_Type', response['type']);
          localStorage.setItem('Daro_User_CanLetterHistory', response['canLetterHistory']);

          var Menu: Array<Nav_Interface> = response['menu_user']
          localStorage.setItem('Daro_User_Nav', JSON.stringify(Menu));

          this.router.navigate(['/Dashboard']);
          this.ReadData_Loging_KeySearch()
        }

      }
    )
  }




  ReadData_Loging_KeySearch_Timer: any
  ReadData_Loging_KeySearch() {

    if (this.ReadData_Loging_KeySearch_Timer) {
      clearTimeout(this.ReadData_Loging_KeySearch_Timer);
      this.ReadData_Loging_KeySearch_Timer = null;
    }

    this.ReadData_Loging_KeySearch_Timer = setTimeout(function () {
      this.LogingFunctionReload()
    }.bind(this), 1000);

  }

  LogingFunctionReload() {
    location.reload();
  }


}
